import React from 'react';
import useBannerNavigation from 'legacyfrontend/hooks/useBannerNavigation';
import commons from 'legacyfrontend/components/commons';
import {
  TEMPLATE_CONFIG,
  buildTemplatePreviewModel,
  normalizeBannerForTemplate,
} from '../model/bannerModel';
import { normalizeImageShade } from '../model/imageShade';
import TemplateCard from './TemplateCard';
import '../styles/banners-v1.css';

type EmpresaBannerCardProps = {
  data: Record<string, unknown>;
  className?: string;
  hoverOverlay?: boolean;
  templateOverride?: number;
};

export default function EmpresaBannerCard({
  data,
  className,
  hoverOverlay,
  templateOverride,
}: EmpresaBannerCardProps) {
  const { getNavigationProps } = useBannerNavigation();
  const navigationProps = getNavigationProps(data);
  const normalized = normalizeBannerForTemplate(data);
  const template = templateOverride ?? (Number(data.template) || 1);
  const config = TEMPLATE_CONFIG[template as keyof typeof TEMPLATE_CONFIG] || TEMPLATE_CONFIG[1];
  const imageUrl = commons.imgUrlValidator(normalized.imageUrl);
  const mobileImageUrl = normalized.imagenMobile
    ? commons.imgUrlValidator(normalized.imagenMobile)
    : '';
  const model = buildTemplatePreviewModel({ ...normalized, imageUrl, mobileImageUrl, template });
  const crop = {
    zoom: data.zoom as number | null | undefined,
    offsetX: data.offsetX as number | null | undefined,
    offsetY: data.offsetY as number | null | undefined,
    zoomLibre: Boolean(data.zoomLibre),
  };

  return (
    <div
      className={['mb-banner-v1 w-full h-full', className].filter(Boolean).join(' ')}
      id={String(data.id)}
    >
      <a
        className='block w-full h-full'
        href={navigationProps.href}
        rel='noreferrer'
        target={navigationProps.target}
      >
        <TemplateCard
          crop={crop}
          frameRatio={config.ratio}
          hoverOverlay={hoverOverlay}
          imageShade={normalizeImageShade(normalized.degradeImagen)}
          model={model}
          template={template}
        />
      </a>
    </div>
  );
}
